import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: Number }

  connect() {
    const timeout = this.delayValue || 3500
    this.timer = window.setTimeout(() => this.dismiss(), timeout)
    // Ensure CSS animation restarts when the element is re-rendered via Turbo
    const bar = this.element.querySelector("[data-flash-bar]")
    if (bar) {
      bar.style.animation = "none"
      // force reflow
      // eslint-disable-next-line no-unused-expressions
      bar.offsetHeight
      bar.style.animation = `flash-countdown ${timeout}ms linear forwards`
    }
  }

  disconnect() {
    if (this.timer) window.clearTimeout(this.timer)
  }

  dismiss(event) {
    if (event) event.preventDefault()
    if (this.timer) window.clearTimeout(this.timer)
    this.element.classList.add("opacity-0", "translate-y-1", "pointer-events-none")
    window.setTimeout(() => {
      if (this.element && this.element.parentNode) {
        this.element.parentNode.removeChild(this.element)
      }
    }, 200)
  }
}
